export default "__VITE_PUBLIC_ASSET__8316e101__"